<script>
import CommentItem from "./CommentItem.vue";

export default {
  name: "CommentList",
  components: { CommentItem },
  emits: ["reply"],
  props: {
    commentShowMore: {
      type: Boolean,
      default: true
    },
    canReplay: {
      type: Boolean,
      default: false
    },
    commentList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    onReply(comment) {
      this.$emit("reply", comment);
    }
  }
};
</script>

<template>
  <div class="comment-list">
    <div v-for="comment in commentList" :key="comment.id">
      <CommentItem :canReplay="canReplay" :comment="comment" :commentShowMore="commentShowMore" @reply="onReply"></CommentItem>
    </div>
  </div>
</template>

<style scoped>

</style>
